module.exports = __webpack_public_path__ + "static/media/Novecentowide-Normal.0e18cc00.otf";